export class MujocoPoseMapping {
    name: string;
    qpos_range_position: string;
    qpos_range_orientation: string;
    qpos_range_joint: string;
}
